import { useState, useEffect } from 'react';
import TablaPerfil from "../components/TablaPerfil";
import { message } from 'antd';
import axios from "./../../../services/http";

const ListadoPerfilLayout = ({ realodData, EditProfile }) => {

    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        GetProfiles();
    }, [realodData]);

    const GetProfiles = async () => {
        try {
            setLoading(true);
            const response = await axios.HTTP_POST("/api/v1/profiles/list", {});
            setProfiles(response.data);
        } catch (e) {
            console.error('Error al obtener los perfiles:', e);
            message.error('Error al obtener los perfiles');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {/* Aqui van los filtros */}

            <TablaPerfil
                data={profiles}
                loading={loading}
                setLoading={setLoading}
                GetProfiles={GetProfiles}
                EditProfile={EditProfile}
            />
        </>
    )
}

export default ListadoPerfilLayout;